import {
  Component,
  Emit,
  Mixins,
  Model,
  Prop,
  Ref,
} from 'vue-property-decorator';

import { ResizableDrawerMixin } from '../../../mixins/ResizableDrawerMixin';
import VMenuList from '../VMenuList/VMenuList.vue';

import type { LocaleMessages } from 'vue-i18n';
import type { Vue } from 'vue-property-decorator';

export interface DrawerItem {
  title: string | LocaleMessages;
  icon: string;
  component: any;
}

@Component({
  components: { VMenuList },
})
export default class NestedDrawer extends Mixins(ResizableDrawerMixin) {
  @Ref('NestedDrawer') readonly nestedDrawer!: Vue;

  @Prop({ type: Number })
  readonly width!: number;

  @Prop({ type: Number })
  readonly menuWidth!: number;

  @Prop({ type: Array })
  readonly items!: DrawerItem[];

  @Model('input', {})
  value!: number | false;

  widthLocal: number | string | null = null;

  get activeItemComponent(): any {
    if (typeof this.activeItem === 'number') {
      return this.items[this.activeItem].component;
    }
    return false;
  }

  get drawerWidth(): number | string | null {
    return this.activeItem !== false ? this.widthLocal : this.menuWidth;
  }

  get activeItem(): number | false {
    return this.value;
  }

  set activeItem(val: number | false) {
    const result = val !== undefined ? val : false;
    this.updateValue(result);
  }

  @Emit('input')
  updateValue(val: number | false): number | false {
    return val;
  }

  mounted(): void {
    this.widthLocal = this.width;
    this.makeResizable(
      this.nestedDrawer.$el as HTMLElement,
      (width) => {
        this.widthLocal = width;
        // console.log(width);
      },
      { borderClass: 'nested-drawer__border', minWidth: 70 },
    );
  }
}
